import { ContentHeader, LayoutWithNavigationBreadcrumbs } from 'components';
import { type FormSubmit } from 'libs/form';
import { useTranslation } from 'libs/i18n';
import { RoutesId } from 'libs/navigation';
import { Stack } from 'libs/ui';

import { FormContent, FormFooter } from '../components';
import {
  type CreateClientFormType,
  Form,
  type FormErrors,
  getSchema,
} from '../forms/createClientForm';

interface Props {
  formError: FormErrors | undefined;
  submitLoading: boolean;
  onSubmit: FormSubmit<CreateClientFormType>;
}

export const CreateClientView = ({
  formError,
  submitLoading,
  onSubmit,
}: Props) => {
  const { t } = useTranslation();
  return (
    <LayoutWithNavigationBreadcrumbs
      titles={{
        [RoutesId.personClients]: t('client.clients.personal.title'),
        [RoutesId.createPersonClient]: t('client.createClient.title'),
      }}
    >
      <Stack spacing={24}>
        <Form
          initialErrors={formError}
          validationSchema={getSchema(t)}
          onSubmit={onSubmit}
        >
          <ContentHeader header={t('client.createClient.title')} />
          <FormContent />
          <FormFooter submitLoading={submitLoading} />
        </Form>
      </Stack>
    </LayoutWithNavigationBreadcrumbs>
  );
};
